import React from 'react';

const JS_Async_Await = () => {
  return (
    <div >
      <h1>JS_Async_Await</h1>
      <p>Placeholder component for: "JS Async/Await"</p>
    </div>
  );
};

export default JS_Async_Await;
